import React from 'react';
import PropTypes from 'prop-types';
import PopupWindow, { invokePopup} from '../../shared/PopupWindow';
import LoginForm from './LoginFormNoPopup';


const hideAllErrors = () => {
  const errorBoxes = document.getElementsByClassName('errorMsg');
  if (errorBoxes.length) {
    Object.values(errorBoxes).forEach(function(element) {
      element.classList.remove('visible');
    });
  }
};

const LoginFormOpen = (event, popupId) => {
  invokePopup(event, popupId);
  hideAllErrors();
};

const LoginFormPopup = ({popupId, redirectUrl}) => {
  return (
    <PopupWindow
      title="เข้าสู่ระบบ"
      popupId={popupId}
      extraClass="title-orange full-width-popup"
    >
      <LoginForm popupId={popupId} redirectUrl={redirectUrl} />
    </PopupWindow>
  );
};
export default LoginFormPopup;
export { LoginFormOpen };

LoginFormPopup.propTypes = {
  popupId: PropTypes.string,
  redirectUrl: PropTypes.string
};
